import React from 'react';
import {
  Grid,
  TextField,
  MenuItem,
  Typography,
  FormControl,
  Select,
  IconButton,
  InputAdornment,
  Tooltip,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Clear } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { SEARCH_CRITERIA, LIST_OF_ACTIONS, VIEWS } from '../helpers/statusConfig';

const useStyles = makeStyles(() => ({
  wrap: {
    marginTop: 14,
  },
  groupLabel: {
    fontWeight: 550,
    whiteSpace: 'nowrap',
    marginBottom: '1rem',
  },
  criteriaSelect: {
    border: '1px solid black',
    borderRight: 'none',
    borderRadius: '0.1rem',
    backgroundColor: '#F0F0F0',
  },
  searchTextField: {
    flex: 1,
    minWidth: 0,
    border: '1px solid black',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
  },
  searchIconBtn: {
    backgroundColor: '#EB5E28',
    color: 'white',
    borderTopRightRadius: '7px',
    borderBottomRightRadius: '7px',
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
    padding: '8px',
    translate: '0.84rem',
    marginLeft: '0px',
    marginRight: '0px',
  },
  actionSelect: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    '& .MuiOutlinedInput-input': { padding: '8px 10px', fontSize: '0.82rem' },
  },
  synced: {
    color: 'gray',
    marginRight: '8px',
    whiteSpace: 'nowrap',
  },
  refresh: {
    color: 'primary',
    textDecoration: 'underline',
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  perPageLabel: {
    fontWeight: 'bold',
    marginRight: '4px',
    whiteSpace: 'nowrap',
  },
  perPageSelect: {
    minWidth: 70,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    '& .MuiOutlinedInput-input': { padding: '6px 10px', fontSize: '0.82rem' },
  },
  topRow: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    width: '100%',
    flexWrap: 'nowrap',
    marginTop: '1rem',
    gap: '15px',
  },
  syncRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
  },
  perPageRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: '10px',
    width: '100%',
  },
}));

const SearchActionBar = ({
  searchCriteria,
  searchValue,
  onSearchCriteriaChange,
  onSearchValueChange,
  onSearchSubmit,
  onClearSearch,
  shipmentStatuses,
  listOfActions,
  onListOfActionsChange,
  perPage,
  onPerPageChange,
  lastSyncedAt,
  onRefresh,
  view
}) => {
  const classes = useStyles();
  const searchCriteriaOptions = view === VIEWS.PRE_SCHEDULE
    ? SEARCH_CRITERIA.filter((c) => c.key !== 'shipmentStatus')
    : SEARCH_CRITERIA;
  const formattedSynced = lastSyncedAt
    ? moment(lastSyncedAt).format('HH:mm:ss; DD MMMM, YYYY')
    : moment(new Date()).format('HH:mm:ss; DD MMMM, YYYY');
console.log("view",view)
  return (
    <div className={classes.wrap}>
      {/* Search By | List of Actions | Synced + Per Page */}
      <div className={classes.topRow}>
        {/* Search By */}
        <Grid
          item
          xs={12}
          sm={5}
          md={5}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Typography className={`dashboard-filter-labels ${classes.groupLabel}`}>
            Search by:
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', width: '90%' }}>
            <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
              {/* Criteria selector */}
              <TextField
                size="small"
                select
                value={searchCriteria}
                onChange={(e) => {
                  onSearchCriteriaChange(e.target.value);
                  onSearchValueChange('');
                }}
                variant="outlined"
                style={{ backgroundColor: '#F0F0F0', borderRight: 'none', borderRadius: '0.1rem' }}
                className={`select-search ${classes.criteriaSelect}`}
              >
                {searchCriteriaOptions.map((c) => (
                  <MenuItem key={c.key} value={c.key}>{c.label}</MenuItem>
                ))}
              </TextField>

              {/* Value input — dropdown for Shipment Status, text field otherwise */}
              {searchCriteria === 'shipmentStatus' ? (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                  minWidth: 0,
                  border: '1px solid black',
                  borderTopRightRadius: 8,
                  borderBottomRightRadius: 8,
                  overflow: 'hidden',
                }}>
                  <FormControl variant="outlined" size="small" style={{ flex: 1 }}>
                    <Select
                      value={searchValue}
                      onChange={(e) => onSearchValueChange(e.target.value)}
                      displayEmpty
                      style={{ borderRadius: 0, border: 'none' }}
                    >
                      <MenuItem value=""><em>Select status</em></MenuItem>
                      {(shipmentStatuses || []).map((s) => (
                        <MenuItem key={s.status_id} value={String(s.status_id)}>{s.status_name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {searchValue && (
                    <Tooltip title="Clear search" aria-label="clear">
                      <Clear
                        fontSize="small"
                        onClick={() => onClearSearch ? onClearSearch() : onSearchValueChange('')}
                        style={{ cursor: 'pointer', color: 'dimgray', margin: '0 4px' }}
                      />
                    </Tooltip>
                  )}
                  <IconButton
                    size="small"
                    style={{
                      backgroundColor: "#EB5E28",
                      color: "white",
                      borderTopRightRadius: "7px",
                      borderBottomRightRadius: "7px",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      padding: "8px",
                      translate: "0.84rem",
                      marginLeft: "0px",
                      marginRight: "0px",
                    }}
                    onClick={() => onSearchSubmit && onSearchSubmit()}
                  >
                    <SearchIcon />
                  </IconButton>
                </div>
              ) : (
                <TextField
                  size="small"
                  value={searchValue}
                  disabled={searchCriteria === 'all'}
                  onChange={(e) => {
                    if (searchCriteria !== 'all') onSearchValueChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    const { value } = e.target;
                    if (searchCriteria !== 'all' && typeof value === 'string' && value.trim() !== value) {
                      onSearchValueChange(value.trim());
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onSearchValueChange(e.target.value.trim());
                      onSearchSubmit && onSearchSubmit();
                    }
                  }}
                  variant="outlined"
                  placeholder="Search"
                  style={{
                    flex: 1,
                    minWidth: 0,
                    border: '1px solid black',
                    borderTopRightRadius: '8px',
                    borderBottomRightRadius: '8px',
                    borderTopLeftRadius: '0px',
                    borderBottomLeftRadius: '0px',
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {searchValue && (
                          <Tooltip title="Clear search" aria-label="clear">
                            <Clear
                              fontSize="small"
                              onClick={() => onClearSearch ? onClearSearch() : (() => { onSearchValueChange(''); onSearchCriteriaChange('all'); })()}
                              style={{ cursor: 'pointer', color: 'dimgray' }}
                            />
                          </Tooltip>
                        )}
                        <IconButton
                          size="small"
                          style={{
                            backgroundColor: "#EB5E28",
                            color: "white",
                            borderTopRightRadius: "7px",
                            borderBottomRightRadius: "7px",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                            padding: "8px",
                            translate: "0.84rem",
                            marginLeft: "0px",
                            marginRight: "0px",
                          }}
                          onClick={() => onSearchSubmit && onSearchSubmit()}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            </div>
          </div>
        </Grid>

        {/* List of Actions */}
        {view !== 'preSchedule' && (
        <Grid
          item
          xs={12}
          sm={5}
          md={5}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Typography className={`dashboard-filter-labels ${classes.groupLabel}`}>
            List of actions:
          </Typography>
          <div style={{ width: '100%' }} className="dashboard-filter-dropdown">
            <FormControl variant="outlined" size="small" className={classes.actionSelect}>
              <Select
                value={listOfActions}
                onChange={(e) => onListOfActionsChange(e.target.value)}
                displayEmpty
              >
                {LIST_OF_ACTIONS.map((l) => (
                  <MenuItem key={l.key} value={l.key}>{l.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </Grid>
        )}

        {/* Synced + Per Page */}
        <Grid
          item
          style={{ width: '40%', marginLeft: '2rem' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
            {/* Last synced + Refresh */}
            <div className={classes.syncRow}>
              <Typography variant="body2" className={`last-synced-text ${classes.synced}`}>
                {`Last synced @ ${formattedSynced}`}
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                className={`refresh-button ${classes.refresh}`}
                onClick={onRefresh}
              >
                Refresh
                <RefreshIcon color="primary" fontSize="small" />
              </Typography>
            </div>

            {/* Per Page */}
            <div className={`per-page-box ${classes.perPageRow}`}>
              <Typography className={classes.perPageLabel}>PER PAGE</Typography>
              <FormControl variant="outlined" size="small" className={classes.perPageSelect}>
                <Select
                  value={perPage}
                  onChange={(e) => onPerPageChange(e.target.value)}
                >
                  {[5, 10, 50, 100].map((n) => (
                    <MenuItem key={n} value={n}>{n}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </Grid>
      </div>
    </div>
  );
};

export default SearchActionBar;
